import {FileStack} from '@crema/modules/thirdParty';
export default FileStack;
